import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { FAQ_FAQ_QUESTION_SET_DATA, FAQ_FAQ_QUESTION_RESET_DATA } from 'rebook/apps/faq/constants';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';


export function fetchInitialData(match, location = {}) {
  return async(dispatch, getState) => {
    const { questionSlug } = match.params;
    const currentState = getState().faqQuestion;
    let newState = {
      questionSlug,
    };
    // obtain partial state from router (client side only)
    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }
    if (currentState.title) {
      newState = {
        ...newState,
        ...currentState,
      };
    }
    dispatch(setData(newState));

    if (!newState.content) {
      await dispatch(fetchQuestionDetail(match));
    }
  };
}

export function fetchQuestionDetail(match) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const { questionSlug } = match.params;
    const url = `/api/faq-questions/s-${questionSlug}/`;
    return await fetchQuery(url, { headers: ssr.headers })
      .then(
        ({ data }) => {
          dispatch(setData({
            content: data.answer,
            title: data.question,
            sectionSlug: data.section_slug,
          }));
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to load static page due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
          throw new Error('failed to load static page due to server error');
        }
      );
  };
}

export function setSeoMeta() {
  return (dispatch, getState) => {
    const { faqQuestion, booksPerSubscriptionCounter } = getState();
    dispatch(SeoActions.setData({
      title: `${faqQuestion.title} Вопросы и ответы об электронной библиотеке MyBook помогут вам. ` +
      `Читайте более ${booksPerSubscriptionCounter.total} книг по подписке на iPhone, iPad, Android`,
      canonicalUrl: `https://${BASE_HOST}/help/`,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { title } = payload;
    dispatch({
      type: FAQ_FAQ_QUESTION_SET_DATA,
      payload,
    });
    if (title) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch({
      type: FAQ_FAQ_QUESTION_RESET_DATA,
    });
    dispatch(SeoActions.resetData());
  };
}
